import type { Criticality } from '@/lib/data/types'

/** Global filters. They apply to every tab and to every sheet that has the column. */
export interface Filters {
    division: string | null
    bu: string | null
    owner: string | null
    program: string | null
    domain: string | null
    criticality: Criticality | null
    /** Y:2026 for a year, Q:2026:3 for a quarter */
    period: string | null
    onlyCritical: boolean
    /** Reference (cut-off) date. Null means the latest available cut. */
    cut: number | null
}

export const EMPTY_FILTERS: Filters = {
    division: null,
    bu: null,
    owner: null,
    program: null,
    domain: null,
    criticality: null,
    period: null,
    onlyCritical: false,
    cut: null
}

export const countActiveFilters = (filters: Filters): number => {
    let count = 0

    if (filters.division) count++
    if (filters.bu) count++
    if (filters.owner) count++
    if (filters.program) count++
    if (filters.domain) count++
    if (filters.criticality) count++
    if (filters.period) count++
    if (filters.onlyCritical) count++

    return count
}

export const yearKey = (year: number): string => `Y:${year}`

export const quarterKey = (year: number, quarter: number): string => `Q:${year}:${quarter}`

/** Start and end (UTC midnight) of a period filter value. */
export const periodRange = (key: string | null): { start: number, end: number } | null => {
    if (!key) return null

    const parts = key.split(':')

    if (parts[0] === 'Y') {
        const year = Number(parts[1])

        return { start: Date.UTC(year, 0, 1), end: Date.UTC(year, 11, 31) }
    }

    if (parts[0] === 'Q') {
        const year = Number(parts[1])
        const quarter = Number(parts[2])

        return { start: Date.UTC(year, (quarter - 1) * 3, 1), end: Date.UTC(year, quarter * 3, 0) }
    }

    return null
}
